import stylesheet from "./FeedFooter.module.scss"

export default function FeedFooter({ textColor }: { textColor: string}) {
  return  <p className={stylesheet.styles} style={{ color: textColor }}>That's it! 🎉</p>
}